
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Apply polyfills for older browsers if needed
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Check if we're running in SharePoint
const isInSharePoint = 
  typeof window !== "undefined" && 
  (window._spPageContextInfo !== undefined || window._spPageContext !== undefined);

// Error boundary for the entire application
function renderApp() {
  try {
    // Find the appropriate root element (SPFx webpart or standalone app)
    const root = isInSharePoint 
      ? document.getElementById("spfx-root") 
      : document.getElementById("root");
      
    if (!root) {
      console.error("Root element not found");
      // Create a fallback root if needed
      const fallbackRoot = document.createElement('div');
      fallbackRoot.id = isInSharePoint ? 'spfx-root' : 'root';
      document.body.appendChild(fallbackRoot);
      createRoot(fallbackRoot).render(<App />);
    } else {
      createRoot(root).render(<App />);
    }
    
    console.log("App successfully rendered");
  } catch (error) {
    console.error("Failed to render app:", error);
    
    // Render a fallback UI in case of critical errors
    const rootElement = isInSharePoint 
      ? document.getElementById("spfx-root") 
      : document.getElementById("root");
      
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding: 20px; text-align: center; font-family: system-ui, sans-serif;">
          <h2>Something went wrong</h2>
          <p>The application couldn't be loaded properly. Please try refreshing the page.</p>
          <button onclick="window.location.reload()" style="padding: 8px 16px; margin-top: 16px; cursor: pointer;">
            Refresh Page
          </button>
        </div>
      `;
    }
  }
}

// Initialize app with error catching
renderApp();
